import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

const BASE_URL = process.env.NEXT_PUBLIC_CRONOS_BRIDGE_BASE_URL;

const Seo = ({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) => {
  const router = useRouter();
  const canonical = BASE_URL + router.route;

  return (
    <Head>
      {title && (
        <>
          <title key="title">{title}</title>
          <meta property="og:title" content={title} key="og:title" />
          <meta property="og:image:alt" content={title} key="og:image:alt" />
          <meta name="twitter:title" content={title} key="twitter:title" />
        </>
      )}
      {description && (
        <>
          <meta name="description" content={description} key="description" />
          <meta
            property="og:description"
            content={description}
            key="og:description"
          />
          <meta
            name="twitter:description"
            content={description}
            key="twitter:description"
          />
        </>
      )}
      <link rel="canonical" href={canonical} key="canonical" />
      <meta property="og:url" content={canonical} key="og:url" />
    </Head>
  );
};

export default Seo;
